//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import info from './items/info'
import gold from './items/gold'
import star from './items/star'
import history from './items/history'
import buy from './items/buy'


import setting from './items/setting'
import userhead from './items/head'

Vue.component('userhead', userhead)

import '../../../assets/css/user.css'

export default {
  name: 'usercentr',
  components: {
    info,
    gold,
    setting,
    star,
    history,
    buy
  },
  data() {
    return {
      show_what: 'info',
      user: {},
    }
  },
  watch: {
    '$route'(to, from) {
      console.log("to:", to, "from:", from);
      console.log('this.$route.params.id:', this.$route.params.id);
      this.show_what = this.$route.params.id;
    }
  },
  created() {
    window._t = this;
    console.log('this.$route.query.id:', this.$route.query.id);
    console.log('this.$route.params.id:', this.$route.params.id);
    this.show_what = this.$route.params.id;

    this.listener_login = this.$hub.on('event:login', (data) => {
      console.log('event:login', data);
      this.$forceUpdate();
    });
  },
  destroyed() {
    this.listener_login.off();
  },
  methods: {
    on_submit: function () {

    },

  }

}
